import React from "react";
import { Link } from "react-scroll";

import Dapp1 from "../assets/Dapp1.jpg";
import Dapp2 from "../assets/project2.png";
import Dapp3 from "../assets/Dapp3.png";

import FunSwap from "../assets/Uniswap.png"
import Mern1 from  "../assets/Mern1.png"
import Dapp4 from "../assets/project3.png";

const Projects = () => {
 
  return (
    <div
      name="projects"
      className="w-full font-semibold text-black my-32  md:h-screen "
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8 ">
        <Link 
        
              to="projects"
              smooth
              duration={800} 
              className="text-4xl font-bold inline border-b-4 border-gray-500" 
          >
            Projects
        </Link>
          <p className="py-6 text-xl " data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000" data-aos-easing="ease-in-sine">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0 " >
         
            <div data-aos="zoom-out-up" data-aos-duration="900" className="shadow-md shadow-gray-600 rounded-lg" target="_blank">
              <img
                src={Dapp1}
                alt=""
                className="rounded-md duration-200 hover:scale-105 h-52"
              />
              <div className="flex items-center justify-center">
                <a  href = "https://payeth4fun.netlify.app/" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank" >
                  Demo
                </a>
                <a  href = "https://github.com/Anmo1Sen/KRYPT_TransferDapp"className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank">
                  Code
                </a>
              </div>
            </div>


           

            <div data-aos="zoom-out-up" data-aos-duration="1100" className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={FunSwap}
                alt=""
                className="rounded-md duration-200 hover:scale-105 h-52"
              />
              <div className="flex items-center justify-center">
              <a href="https://funswap.netlify.app/" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank" >
                  Demo
                </a>
                <a href = "https://github.com/Anmo1Sen/FunSwap" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105 " target="_blank">
                  Code
                </a>
              </div>
            </div>


            <div data-aos="zoom-out-up" data-aos-duration="1700" className="shadow-md shadow-gray-600 rounded-lg">
             
              <img
                src= {Dapp4}
                alt=""
                
                className="rounded-md duration-200 hover:scale-105 h-52 min-w-full"
              />
            
              <div className="flex items-center justify-center">
                <a href="https://confesster-dapp-wheat.vercel.app/" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank" >
                  Demo
                </a>
                <a href="https://github.com/Anmo1Sen/Confesster_Dapp"
                className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank">
                  Code
                </a>
              </div>
            </div>

            <div data-aos="zoom-out-up" data-aos-duration="900" className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={Mern1}
                alt=""
                className="rounded-md duration-200 hover:scale-105 h-52"
              />
              <div className="flex items-center justify-center">
                <a  href = "https://personaledger.netlify.app/" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank" >
                  Demo
                </a>
                <a  href = "https://github.com/Anmo1Sen/Mern_App2"className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank">
                  Code
                </a>
              </div>
            </div>

            <div data-aos="zoom-out-up" data-aos-duration="1500" className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={Dapp2}
                alt=""
                className="rounded-md duration-200 hover:scale-105 h-52"
              />
              <div className="flex items-center justify-center">
                <a  href = "https://dapperc20.herokuapp.com/"className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank">
                  Demo
                </a>
                <a  href = "https://github.com/Anmo1Sen/ERC-20_Dapp" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank">
                  Code
                </a>
              </div>
            </div>
      
            <div  data-aos="zoom-out-up" data-aos-duration="1300" className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={Dapp3}
                alt=""
                className="rounded-md duration-200 hover:scale-105 h-52"
              />
              <div className="flex items-center justify-center">
                <a  href = "https://nft-marketplacesight.netlify.app" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank">
                  Demo
                </a>
                <a  href = "https://github.com/Anmo1Sen/NFTmarketPlace" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105" target="_blank">
                  Code
                </a>
              </div>
            </div>


          



          


           
        
 

        
        </div>
      </div>
    </div>
  );
};

export default Projects;